import {
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import { BgRemovalStrategy } from "@towersystems/roam-common/lib/generated-types";
import { BackgroundEraserFormValues } from "../../../components/BackgroundEraserForm";
import { useFormContext } from "react-hook-form";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { BackgroundEraserRootParamList } from "../../../types";
import React from "react";

export type SelectBgRemovalStrategyScreenProps = NativeStackScreenProps<
  BackgroundEraserRootParamList,
  "SelectBgRemovalStrategyScreen"
>;

const StrategyMapping: Record<
  BgRemovalStrategy,
  { title: string; description: string }
> = {
  [BgRemovalStrategy.RemovalBgStrategy]: {
    title: "Remove.bg",
    description: "Use Remove.bg for background removal.",
  },
  [BgRemovalStrategy.RemovalAiStrategy]: {
    title: "Removal AI",
    description: "Use Removal AI for background removal.",
  },
};

export const SelectBgRemovalStrategyScreen = ({
  navigation,
}: SelectBgRemovalStrategyScreenProps) => {
  const { setValue, reset, watch } =
    useFormContext<BackgroundEraserFormValues>();

  const watchedBgRemovalStrategy = watch("bgRemovalStrategy");

  const actions: FlatActionListItem[] = React.useMemo(() => {
    return Object.entries(StrategyMapping).map(([key, value]) => {
      return {
        key,
        title: value.title,
        subTitle: value.description,
        selected: watchedBgRemovalStrategy === key,
        onPress: () => {
          setValue("bgRemovalStrategy", key as BgRemovalStrategy, {
            shouldValidate: true,
            shouldDirty: true,
          });
          navigation.goBack();
        },
      };
    });
  }, [watchedBgRemovalStrategy, setValue, reset]);

  return (
    <Page
      title="Select Background Removal Strategy"
      secondaryTitle="Choose your preferred background removal strategy."
    >
      <FlatActionList items={actions} />
    </Page>
  );
};
